export const INVITE_MEMBERS_STEPS = {
    CREATE_INVITE: 'CREATE_INVITE',
    SUCCESS: 'SUCCESS',
};
export const INVITE_TYPES = {
    individual: 'individual',
    organization: 'organization',
};
export const INVITE_MEMBERS_FIELD_NAMES = {
    emailFilters: 'emailFilters',
    type: 'type',
    groups: 'groups',
};
export const INDIVIDUAL_INVITE_GENERAL_SERVER_ERROR_CODE = 'invitation.emailFilters';
